import { useMapPublishProperties } from "../../../hooks/react-query/properties/useMapPublishPropertyList";
import { usePublishProperties } from "../../../hooks/react-query/properties/usePublishPropertyList";
import PropertyListing from "../../../stories/property-list/property-listing";
import styles from "./property-list.module.scss";

const PropertyList = () => {
  const {
    arrProperty,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isPlaceholderData,
    isFetchingNextPage
  } = usePublishProperties({ type: "agent" });
  const { arrMapProperty } = useMapPublishProperties({ type: "agent" });
  return (
    <div className={styles.propertyList}>
      <div className={styles.content}>
        <PropertyListing
          type="agent"
          arrProperty={arrProperty}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isLoading={isLoading}
          isPlaceholderData={isPlaceholderData}
          isFetchingNextPage={isFetchingNextPage}
          arrMapProperty={arrMapProperty}
        />
      </div>
    </div>
  );
};

export default PropertyList;
